module.exports = __webpack_public_path__ + "img/info.c534d077.svg";